import React, { useEffect } from "react";
import { useState } from "react";
import { usePageContextState } from "../../../context/PageContext";
import useWindowSize from "../../../hooks/useWindowSize";
import { useFetchGroupMatch, useFetchKnockoutMatch } from "../../../networks";
import { getStaticImg } from "../../../utils/function";
import ImagePreview from "../ImagePreview";
import { ButtonContainer, TabBarContainer } from "./StandingCard.styled";
import classNames from "classnames";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;

/**
 * @deprecated
 * You can use StandingCardNew Component
 */
const StandingCard = ({
  activeCard = "basketSchedule",
  activeKo = "basketKO",
}) => {
  const { city } = usePageContextState();
  const { size } = useWindowSize();
  const { data: dataKlasemen } = useFetchGroupMatch(city);
  const { data: dataKnockout } = useFetchKnockoutMatch(city);
  const [activeTab, setActiveTab] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [imagePreviewModal, setImagePreviewModal] = useState(false);

  const isHighSchool = activeCard?.includes("sma");
  const activeTabbarColor = isHighSchool ? "#00BCF1" : "#77B341";

  const dataRaw = dataKlasemen?.data?.data;
  const dataRaw2 = dataKnockout?.data?.data;

  /* Mapping Data */
  const isMobileView = (size?.width || 0) <= 568;
  const kV = isMobileView ? "key_visual_mobile" : "key_visual";

  const dataItemsKlasemen = dataRaw?.[activeCard];
  const dataItemsKnockout = dataRaw2?.[activeKo];

  /**
   * Reset tab position every active card change
   */
  useEffect(() => {
    setActiveTab(0);
  }, [activeCard, setActiveTab]);

  const _renderTabBar = () => (
    <TabBarContainer bgColor={"#274364"}>
      <ButtonContainer
        onClick={() => setActiveTab(0)}
        isActive={activeTab === 0}
        activeBgColor={activeTabbarColor}
      >
        Tabel Group
      </ButtonContainer>
      <ButtonContainer
        onClick={() => setActiveTab(1)}
        isActive={activeTab === 1}
        activeBgColor={activeTabbarColor}
      >
        Bagan Knockout
      </ButtonContainer>
    </TabBarContainer>
  );

  return (
    <div
      className={classNames("standing-card", {
        smpBgColor: !isHighSchool,
        smaBgColor: isHighSchool,
      })}
    >
      {imagePreviewModal && (
        <ImagePreview
          closeButton={() => setImagePreviewModal(false)}
          imgFile={imagePreview}
        />
      )}
      {_renderTabBar()}
      <div className="standing-card__klasemen-container">
        {activeTab === 0 ? (
          <img
            src={
              dataItemsKlasemen
                ? `${imgPath}/${dataItemsKlasemen?.[0]?.[kV]}`
                : getStaticImg("/illustration/default-image.png")
            }
          />
        ) : (
          <img
            onClick={() => {
              if (isMobileView) {
                setImagePreview(`${imgPath}/${dataItemsKnockout?.[0]?.[kV]}`);
                setImagePreviewModal(true);
              }
            }}
            style={{
              cursor: isMobileView ? "zoom-in" : "",
            }}
            src={
              dataItemsKnockout
                ? `${imgPath}/${dataItemsKnockout?.[0]?.[kV]}`
                : getStaticImg("/illustration/default-image.png")
            }
          />
        )}
      </div>
    </div>
  );
};

export default StandingCard;
